
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 46.771 46.771\" id=\"icon-email\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M23.386,0C10.471,0,0,10.47,0,23.386c0,12.915,10.471,23.385,23.386,23.385\r\n\tc12.916,0,23.386-10.471,23.386-23.385C46.771,10.47,36.302,0,23.386,0 M37.076,12.877l-13.69,13.691L9.695,12.877H37.076z\r\n\t M38.686,32.619c0,0.704-0.571,1.275-1.275,1.275H9.361c-0.704,0-1.275-0.571-1.275-1.275V14.874l13.842,13.842\r\n\tc0.402,0.402,0.93,0.603,1.458,0.603s1.056-0.2,1.458-0.603l13.842-13.842V32.619z\"/> </symbol>";
module.exports = sprite.add(image, "icon-email");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/email.svg
 ** module id = 171
 ** module chunks = 24
 **/